import { render } from "./current_dragging.alert.vue?vue&type=template&id=b3d04b72"
import script from "./current_dragging.alert.vue?vue&type=script&lang=js"
export * from "./current_dragging.alert.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__